<template>
  <div class="yeb-guide-conponet">
    <PageLayout contentBgcolor="#FFF">
      <Appbar>
        <v-toolbar-title>
          <span style="font-size: 17px; text-align: center" :style="'color:' + $vuetify.theme.themes.light.headerColor">
            交易规则
          </span>
        </v-toolbar-title>
      </Appbar>
      <div class="guide-container">
        <div class="g-title">规则简介:</div>
        <div class="g-text">
          1.一个自然日结息一次,当结息时,{{ app_my_config.balance.name }}宝{{
            app_my_config.balance.name
          }}必须大于等于1{{ app_my_config.amountUnit.name }}才给与结算利息,小于1{{
            app_my_config.amountUnit.name
          }}的账户不结息。
        </div>
        <div class="g-text">
          2.会员获得的收益在每天凌晨2点整结息，发放后会加到{{ app_my_config.balance.name }}宝{{
            app_my_config.balance.name
          }}，次日进行复利计算。收益{{ app_my_config.amount.name }}≥0.01{{ app_my_config.amountUnit.name }}才结息。
        </div>
        <div class="g-text">3.每日{{ app_my_config.balance.name }}宝转入转出不限制次数</div>
        <div class="g-title">结息公式:</div>
        <div class="g-text">
          利息 = {{ app_my_config.balance.name }}宝账户留存{{
            app_my_config.amount.name
          }}*(万份收益/10000/(24*时*60分钟*60秒)) * (资金在{{ app_my_config.balance.name }}宝账户中的存放时间)
        </div>
      </div>
    </PageLayout>
  </div>
</template>
<script>
import Appbar from '@c/layout/Appbar'
import PageLayout from '@c/layout/PageLayout'

export default {
  data: function() {
    return {}
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    app_my_config() {
      return this.$store.getters['app/app_my_config']
    }
  },
  components: {
    PageLayout,
    Appbar
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" >
.yeb-guide-conponet {
  flex: 1;
  .guide-container {
    padding: 24px 12px;
  }
  .g-title {
    font-size: 18px;
    color: #333;
    font-weight: 700;
    line-height: 40px;
  }
}
</style>
